import { useTranslation } from 'react-i18next';
import {
    CardContent, CardMedia, Card, Button, TextField, InputLabel,
} from '@material-ui/core';
import { Spinner } from '@commonClient2/components';

import './Login.scss';

/**
 * @param {{
 *  account: { username: string, password: string };
 *  logo: string;
 *  handleSubmitLogin: import('react').FormEventHandler<HTMLFormElement>;
 *  handleChange: import('react').ChangeEventHandler<HTMLInputElement>;
 *  isSpinnerVisible: boolean,
 * }} param0
 */
const LoginForm = ({
    account, handleSubmitLogin, handleChange, isSpinnerVisible, logo,
}) => {
    const { t } = useTranslation('common', { keyPrefix: 'Login' });
    return (
        <div className="sb-login-container">
            <Card className="login-content">
                <CardMedia
                    component="img"
                    image={logo}
                />
                <CardContent className="login-card-content">
                    <p className="login-title-text">{t('title')}</p>
                    <form
                        data-parsley-validate=""
                        onSubmit={handleSubmitLogin}
                        noValidate
                        className="mb-lg"
                    >
                        <div>
                            <InputLabel
                                className="input-label"
                                htmlFor="username"
                            >
                                {t('username')}
                            </InputLabel>
                            <TextField
                                id="username"
                                name="username"
                                type="text"
                                placeholder={t('username')}
                                autoComplete="off"
                                onChange={handleChange}
                                required
                                value={account.username}
                                variant="outlined"
                            />
                        </div>
                        <div>
                            <InputLabel
                                className="input-label"
                                htmlFor="password"
                            >
                                {t('password')}
                            </InputLabel>
                            <TextField
                                id="password"
                                name="password"
                                type="password"
                                placeholder={t('password')}
                                onChange={handleChange}
                                required
                                value={account.password}
                                variant="outlined"
                            />
                        </div>
                        <Button
                            disabled={isSpinnerVisible}
                            type="submit"
                            className="buttonSubmit"
                        >
                            {t('login')}
                        </Button>
                    </form>
                </CardContent>
            </Card>
            <span className="copyRights">{t('copyRights')}</span>
            {isSpinnerVisible && (
                <div className="spinner-container">
                    <Spinner />
                </div>
            )}
        </div>
    );
};

export default LoginForm;
